/**
 * When to introduce credits, as a pure decision.
 *
 * Split out of the hook because every rule here exists to prevent a specific
 * misfire, and those are worth asserting directly rather than through a render.
 */
const NOTHING = {
    hadBonus: false,
    markSeen: false,
    show: false,
};
/** Keeps the latch armed, so the decision is retried on the next change. */
const RETRY = {
    hadBonus: true,
    markSeen: false,
    show: false,
};
export const decideCreditsIntro = ({ uuid, signupBonusRemaining, balanceLoaded, unlimited, bucketsStale, openModalType, hadBonus, alreadySeen, }) => {
    if (!uuid || unlimited)
        return NOTHING;
    /*
      No balance is not a balance of zero. Logout empties this slice a commit
      before it clears the user, so without this the teardown reads exactly like a
      bonus running out and the dialog fires at someone on their way out. The
      latch is passed through untouched: arming it here would make the pre-fetch
      window on every page load look like an observed bonus.
    */
    if (!balanceLoaded)
        return { hadBonus, markSeen: false, show: false };
    if (signupBonusRemaining > 0)
        return RETRY;
    /*
      The transition is the signal, not the zero. Every user whose bonus ran out
      weeks ago reads zero on every page load, and showing them an introduction to
      a system they already use would be the most annoying possible bug here.
    */
    if (!hadBonus)
        return NOTHING;
    /*
      Header sync carries only the aggregate balance, so a failed reconciliation
      leaves the per-bucket split guessed. Wait for a refetch rather than announce
      a milestone off a number we don't trust.
    */
    if (bucketsStale)
        return RETRY;
    if (alreadySeen)
        return NOTHING;
    /*
      One modal slot. Out-of-credits is the more urgent message and explains
      credits itself, so it wins outright rather than queueing; any other modal
      only defers us until it closes.
    */
    if (openModalType === "out-of-credits") {
        return { hadBonus: false, markSeen: true, show: false };
    }
    if (openModalType)
        return RETRY;
    return { hadBonus: false, markSeen: true, show: true };
};
//# sourceMappingURL=creditsIntro.js.map